import { configureStore } from '@reduxjs/toolkit'

import { api } from './api'
import { authReducer } from './auth/auth.slice'
import { clientsReducer } from './shop/clients/clients.slice'
import { ordersReducer } from './shop/orders/orders.slice'

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    auth: authReducer,
    clients: clientsReducer,
    orders: ordersReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
  devTools: process.env.NODE_ENV === 'development',
})

export type RootState = ReturnType<typeof store.getState>
